/**
 * bundle-copy.js — localises spend-threshold figures baked into merchant copy.
 *
 * Marketing blocks (collection marquees, PDP upsell subtitle, banners) hard-code the
 * ladder as prose, e.g. "Spend {t1} → 10% off | {t2} → 15% off". Liquid renders that
 * once, in shop currency, so a shopper in another market sees the wrong figure. Here
 * the {t1}..{tN} tokens are filled with the tier thresholds — already converted to the
 * buyer's presentment currency and formatted in their money format by the shared engine
 * — so a single English string reads correctly in every market. Editing a threshold in
 * Theme Settings also updates every piece of this copy, since it all reads one ladder.
 *
 * Runs synchronously at load, before theme.js upgrades the marquee (which clones the
 * ticker text for scrolling), so every clone inherits already-localised copy. The pass
 * is idempotent — a text node with no tokens is left untouched — so a late clone is safe
 * too. Requires window.theme.bundleTiers (bundle-tiers.js) and window.theme.bundleTiersData.
 */
(function () {
  'use strict';

  const BT = window.theme && window.theme.bundleTiers;
  const raw = window.theme && window.theme.bundleTiersData;
  if (!BT || !raw) return;

  // parseTiers() already runs each min through toPresentment(); formatMoneyShort()
  // already reads the market's moneyFormat — so each token is buyer-currency ready.
  const tiers = BT.parseTiers(raw);
  if (!tiers.length) return;

  const tokens = {};
  tiers.forEach((t, i) => {
    tokens['t' + (i + 1)] = BT.formatMoneyShort(t.min);
  });

  // Free shipping is AU-only: bundle-tiers-data strips the flag outside that
  // market, so these tokens empty themselves wherever the reward doesn't exist.
  // One token per copy shape: freeship (product accordions), shipseg (flat
  // ladders), shipmarq (marquee tail), shipbb (bundle-builder banner tail).
  const shipTier = tiers.filter((t) => t.free_shipping).pop();
  const shipMoney = shipTier ? BT.formatMoneyShort(shipTier.min) : '';
  const shipPct = shipTier && shipTier.percent ? shipTier.percent + '% + ' : '';
  tokens.freeship = shipTier ? 'Free shipping over ' + shipMoney : '';
  tokens.shipseg = shipTier ? '| ' + shipMoney + ' → + Free Shipping' : '';
  tokens.shipmarq = shipTier ? '→ ' + shipMoney + ' + free shipping ' : '';
  tokens.shipbb = shipTier ? '| ' + shipMoney + ' → ' + shipPct + 'free shipping' : '';

  const TOKEN = /\{(t[1-9]\d*|freeship|shipseg|shipmarq|shipbb)\}/;

  function fill() {
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) =>
        TOKEN.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT
    });

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      node.nodeValue = node.nodeValue.replace(/\{(t[1-9]\d*|freeship|shipseg|shipmarq|shipbb)\}/g, (match, key) => {
        return Object.prototype.hasOwnProperty.call(tokens, key) ? tokens[key] : match;
      });
    });
  }

  if (document.body) {
    fill();
  } else {
    document.addEventListener('DOMContentLoaded', fill);
  }
})();
